var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProcessing = function SvgProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#processing_svg__a)",
    d: "M49.04 46.516A2.486 2.486 0 0 0 46.558 49a2.486 2.486 0 0 0 2.484 2.484A2.487 2.487 0 0 0 51.525 49a2.487 2.487 0 0 0-2.484-2.484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#processing_svg__b)",
    d: "M90.749 46.159a41.5 41.5 0 0 0-3.778-14.785L66.19 27.833l6.337-6.338a35.84 35.84 0 0 0-20.645-8.55v5.596H46.2v-5.596C28.518 14.326 14.367 28.477 12.986 46.16h5.595v5.683h-5.595c1.38 17.68 15.532 31.832 33.213 33.213V79.46h5.683v5.595c17.682-1.38 31.833-15.532 33.213-33.213H79.5v-5.683zM72.873 68.813l-4.019 4.019-16.41-16.411a8.1 8.1 0 0 1-3.403.746c-3.504 0-6.5-2.22-7.656-5.325H29.87v-5.683h11.515c1.157-3.106 4.152-5.325 7.656-5.325 4.503 0 8.166 3.663 8.166 8.166a8.1 8.1 0 0 1-.745 3.403z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#processing_svg__c)",
    d: "M97.46 51.841h-6.665c-.673 10.109-4.932 19.52-12.163 26.75C70.728 86.497 60.22 90.85 49.041 90.85s-21.688-4.353-29.592-12.257C11.545 70.687 7.192 60.178 7.192 49s4.353-21.687 12.257-29.592S37.862 7.151 49.041 7.151s21.687 4.353 29.591 12.257l2.01 2.01-2.66 2.66 11.412 1.945L87.45 14.61l-2.106 2.106-2.009-2.01C74.173 5.547 61.994.5 49.041.5 36.086.5 23.906 5.545 14.746 14.705S.541 36.045.541 49s5.045 25.134 14.205 34.295c9.16 9.16 21.34 14.205 34.295 14.205s25.134-5.045 34.294-14.205c8.488-8.488 13.442-19.568 14.124-31.454"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "processing_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.19436 4.49853 -4.17308 -3.89091 51.147 46.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "processing_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.155 38.777 26.322)scale(92.6091 86.1184)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "processing_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.971 43.56 23.006)scale(120.061 111.368)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })))));
};
export default SvgProcessing;